export default {
    props: {
        course: {
            type: Object,
            required: true
        }
    }
}